import { HOST } from "../constants/HostConstants";

export const commentDeleteAdmin = async (comment_id) => {
  try {
    const res = await fetch(`${HOST}/api/comment/commentDelete`, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ comment_id }),
    });
    const data = await res.json();
    return data;
  } catch (err) {
return { success: false, error: err.message };
  }
};
